<template>
  <a-modal
    :title="title"
    v-model:visible="visible"
    :confirm-loading="uploading"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin tip="上传中..." :spinning="uploading">
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <p class="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p class="ant-upload-text">请将文件拖拽到此处上传❥(^_-)</p>
        <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
      </a-upload-dragger>
      <!-- <a
        @click="importTemplate"
        v-hasPermi="['system:projectUser:importTemplate']"
        >下载模板</a
      > -->
    </a-spin>
  </a-modal>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { InboxOutlined } from '@ant-design/icons-vue'
import {
  importProjectUserTemplate,
  importProjectUserData,
} from '@/api/system/user'
import { showImportResult, isImportSuccessCode } from '@/utils/importResult'

const emit = defineEmits(['ok'])
const store = useStore()

const title = ref('用户导入')
const visible = ref(false)
const fileList = ref([])
const uploading = ref(false)
const updateSupport = ref(0)

/** 导入excel窗体关闭 */
const importExcelHandleCancel = (e) => {
  visible.value = false
  fileList.value = []
  // 关闭后刷新列表
  emit('ok')
}

/** 下载模板操作 */
const importTemplate = () => {
  // 调用项目用户导入模板接口
  importProjectUserTemplate({})
    .then((response) => {
      // 创建 Blob 对象
      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // 创建下载链接
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = '项目用户导入模板.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      message.success('模板下载成功')
    })
    .catch(() => {
      message.error('下载模板失败')
    })
}

/** 导入excel窗体开启 */
const importExcelHandleOpen = (e) => {
  visible.value = true
}

const beforeUpload = (file) => {
  fileList.value = [file]
  return false
}

/** 导入excel */
const importExcelHandleChange = () => {
  uploading.value = true
  // 从 Vuex 获取当前项目ID
  const currentProjectId = store.getters.currentProjectId
  if (!currentProjectId) {
    message.warning('请先选择项目')
    uploading.value = false
    return
  }
  const formData = new FormData()
  formData.append('file', fileList.value[0])
  formData.append('updateSupport', updateSupport.value)
  formData.append('projectId', currentProjectId)
  importProjectUserData(formData)
    .then((response) => {
      if (isImportSuccessCode(response.code)) {
        fileList.value = []
        showImportResult(response)
        visible.value = false
        emit('ok')
      } else {
        message.error(response.message)
        return
      }
    })
    .finally(() => {
      uploading.value = false
    })
}

const handleCheckedUpdateSupport = () => {
  updateSupport.value = updateSupport.value === 0 ? 1 : 0
}

const handleRemove = () => {
  fileList.value = []
  uploading.value = false
}

// 暴露方法给父组件
defineExpose({
  importExcelHandleOpen,
  importTemplate,
})
</script>
